import React, { useState, useEffect } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Page404 from '../page404';
// import { Header, Footer, LeftMenu } from "../commons/components";
// import { Content } from "./components";
import Mainhome from './home';
import DetailTheme from './Detail';
import AddTheme from './Add';
import EditTheme from './Edit';
import { getAllCustomers } from './actions';
import { Redirect } from 'react-router';
import { isAuth } from '../auth/actions';

export default function Home() {
  const { path } = useRouteMatch();
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    loadCustomers();
  }, []);
  // console.log( path , '13_path...')

  const loadCustomers = () => {
    getAllCustomers().then((data) => {
      if (data.error) {
        console.log(data.error);
      } else {
        console.log('All Customer', data);
        setCustomers(data);
      }
    });
  };

  return (
    <React.Fragment>
    {isAuth() ? (
      <Switch>
        <Route exact path={path}>
          <Mainhome customers={customers} />
        </Route>
        <Route path={`${path}/add`}>
          <AddTheme />
        </Route>
        <Route path={`${path}/edit/:id`}>
          <EditTheme />
        </Route>
        <Route path={`${path}/detail/:id`}>
          <DetailTheme customers={customers} />
        </Route>
        <Route path={`${path}/*`}>
          <Page404 />
        </Route>
      </Switch>
      ) : (
          <Redirect to='/auth' />
      )}
    </React.Fragment>
  );
}
